import { CollectionArray, CollectionObject, isCollectionArray, isCollectionObject } from '../types/collection';

/**
 * Gets the keys from a collection.
 *
 * ```ts
 * tt.keys({ a: 1, b: 2, c: 3 });
 * // => ['a', 'b', 'c']
 * ```
 */
export function keys<A>(collection: CollectionArray<A> | CollectionObject<A>): string[] | number[] {
  if (isCollectionArray(collection)) {
    return Array.from(collection.keys());
  } else if (isCollectionObject(collection)) {
    return Object.keys(collection);
  } else {
    return [];
  }
}
